import { areViewsEqual as s } from "./views.mjs";
const u = ({
  date: e,
  disableFuture: n,
  disablePast: t,
  maxDate: r,
  minDate: o,
  isDateDisabled: c,
  utils: d,
  timezone: h
}) => {
  const i = d.startOfDay(d.dateWithTimezone(void 0, h));
  t && d.isBefore(o, i) && (o = i), n && d.isAfter(r, i) && (r = i);
  let f = e, a = e;
  for (d.isBefore(e, o) && (f = o, a = null), d.isAfter(e, r) && (a && (a = r), f = null); f || a; ) {
    if (f && d.isAfter(f, r) && (f = null), a && d.isBefore(a, o) && (a = null), f) {
      if (!c(f))
        return f;
      f = d.addDays(f, 1);
    }
    if (a) {
      if (!c(a))
        return a;
      a = d.addDays(a, -1);
    }
  }
  return null;
}, g = (e, n) => n == null || !e.isValid(n) ? null : n, M = (e, n, t) => n == null || !e.isValid(n) ? t : n, m = (e, n, t) => !e.isValid(n) && n != null && !e.isValid(t) && t != null ? !0 : e.isEqual(n, t), p = (e, n) => {
  const r = [e.startOfYear(n)];
  for (; r.length < 12; ) {
    const o = r[r.length - 1];
    r.push(e.addMonths(o, 1));
  }
  return r;
}, D = (e, n, t) => {
  let r = n;
  return r = e.setHours(r, e.getHours(t)), r = e.setMinutes(r, e.getMinutes(t)), r = e.setSeconds(r, e.getSeconds(t)), r;
}, V = (e, n, t) => t === "date" ? e.startOfDay(e.dateWithTimezone(void 0, n)) : e.dateWithTimezone(void 0, n), l = ["year", "month", "day"], W = (e) => l.includes(e), k = (e, {
  format: n,
  views: t
}, r) => {
  if (n != null)
    return n;
  const o = e.formats;
  return s(t, ["year"]) ? o.year : s(t, ["month"]) ? o.month : s(t, ["day"]) ? o.dayOfMonth : s(t, ["month", "year"]) ? `${o.month} ${o.year}` : s(t, ["day", "month"]) ? `${o.month} ${o.dayOfMonth}` : r ? /en/.test(e.getCurrentLocaleCode()) ? o.normalDateWithWeekday : o.normalDate : o.keyboardDate;
}, O = (e, n) => {
  const t = e.startOfWeek(n);
  return [0, 1, 2, 3, 4, 5, 6].map((r) => e.addDays(t, r));
};
export {
  M as applyDefaultDate,
  m as areDatesEqual,
  u as findClosestEnabledDate,
  p as getMonthsInYear,
  V as getTodayDate,
  O as getWeekdays,
  W as isDatePickerView,
  D as mergeDateAndTime,
  g as replaceInvalidDateByNull,
  k as resolveDateFormat
};
//# sourceMappingURL=date-utils.mjs.map
